<template>
  <main class="flex-1 relative overflow-y-auto focus:outline-none" tabindex="0">
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8">
      <div class="md:flex md:items-center md:justify-between">
        <div class="flex min-w-0">
          <svg-vue class="content-title-icon" icon="font-awesome.store-solid"></svg-vue>
          <h1 class="content-title">
            {{ $t('POS setup') }}
          </h1>
        </div>
        <div class="mt-4 flex md:mt-0 md:ml-4">
          <router-link class="btn btn-app" to="/admin/settings">{{ $t('Back') }}</router-link>
        </div>
      </div>
    </div>
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8">
      <div class="content-card-body">
        <loading :status="loading"></loading>
        <form @submit.prevent="save">
          <div class="px-4 py-5 sm:p-6">
            <div class="grid grid-cols-3 gap-6">
              <div class="col-span-3">
                <label class="form-label" for="pos_scanner_focus_autofocus">
                  {{ $t('Scanner focus autofocus') }}
                </label>
                <input-switch
                  :disabled-label="$t('Scanner autofocus disabled')"
                  :enabled-label="$t('Scanner autofocus disabled')"
                  id="pos_scanner_focus_autofocus"
                  v-model="form.pos_scanner_focus_autofocus"
                ></input-switch>
                <div class="form-description-text">{{ $t('This option will control point of sale barcode scanner auto focus state') }}.</div>
              </div>
              <div class="col-span-3 md:flex md:space-x-2">
                <div class="w-full">
                  <label class="form-label" for="pos_scanner_focus_duration">
                    {{ $t('Scanner focus autofocus duration') }}
                  </label>
                  <input type="number" class="form-input" v-model="form.pos_scanner_focus_duration" />
                </div>
                <div class="w-full">
                  <label class="form-label" for="pos_scanner_focus_duration">
                    {{ $t('Scanner processing delay') }}
                  </label>
                  <input type="number" class="form-input" v-model="form.pos_scanner_processing_delay" />
                </div>
                <div class="w-full">
                  <label class="form-label" for="default_warehouse_id">{{ $t('Default Warehouse') }}</label>
                  <select class="form-input" id="default_warehouse_id" required v-model="form.default_warehouse_id">
                    <option disabled :value="null">{{ $t('Select an option') }}</option>
                    <option v-for="(warehouse, index) in warehouseList" :key="index" :value="warehouse.id">{{ warehouse.name }}</option>
                  </select>
                </div>
              </div>
              <div class="col-span-3 md:flex md:space-x-2">
                <div class="w-full">
                  <label class="form-label" for="pos_categories_default_numbers">
                    {{ $t('Categories default numbers to be displayed at POS') }}
                  </label>
                  <input type="number" id="pos_categories_default_numbers" class="form-input" v-model="form.pos_categories_default_numbers" />
                </div>
                <div class="w-full">
                  <label class="form-label" for="pos_products_default_numbers">
                    {{ $t('Products default numbers to be displayed at POS') }}
                  </label>
                  <input type="number" id="pos_products_default_numbers" class="form-input" v-model="form.pos_products_default_numbers" />
                </div>
              </div>
              <div class="col-span-3">
                <label class="form-label" for="pos_monies">
                  {{ $t('Quick monies') }}
                </label>
                <input type="text" id="pos_monies" placeholder="100,500,1000" class="form-input" v-model="form.pos_monies" />
              <p class="form-description-text">{{$t('Enter comma separated amounts as follows')}} 100,500,1000  ({{$t('Put zero to disabled it')}})</p>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="inline-flex">
              <button class="btn btn-green" type="submit">
                {{ $t('Save') }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: 'pos-setup',
  metaInfo() {
    return {
      title: this.$i18n.t('Pos setup'),
    };
  },
  data() {
    return {
      loading: true,
      warehouseList: [],
      form: {
        pos_monies: '100,500,1000,5000',
        pos_scanner_focus_autofocus: false,
        pos_scanner_focus_duration: 500,
        pos_scanner_processing_delay: 1500,
        default_warehouse_id: 1,
        pos_categories_default_numbers: 20,
        pos_products_default_numbers: 20,
      },
    };
  },
  mounted() {
    this.getWarehouses();
    this.get();
  },
  methods: {
    getWarehouses() {
      axios
        .get(route('warehouses.list'))
        .then((response) => {
          this.warehouseList = response.data;
          this.loading = false;
        })
        .catch(function () {
          this.$router.push('/admin/settings');
        });
    },
    get() {
      axios
        .get(route('settings.get.pos-config'))
        .then((response) => {
          this.form = response.data;
          this.loading = false;
        })
        .catch(function () {
          this.$router.push('/admin/settings');
        });
    },
    save() {
      this.loading = true;
      axios
        .post(route('settings.set.pos-config'), this.form)
        .then((response) => {
          this.loading = false;
          this.$notify({
            title: this.$i18n.t('Success').toString(),
            text: response.data.message.toString(),
            type: 'success',
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
